export default __webpack_public_path__ + "images/3a667003f321f90635216dffec562503.svg";